import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";
import styles from "../../../Homepage/components/Css/EbooksHome.module.css";
import "swiper/css";
import "swiper/css/navigation";
import EbookCard from "../../../components/reading/EbookCards";
import Loading from "../../../common/HousGlass Loader/Loading";
import { useLatestEbooksByLanguage } from "../../../hooks/ebooksByLanguageHooks";

function BookCollection() {
  const [activeLanguage, setActiveLanguage] = useState("english");
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  
  const languages = ["english", "hindi", "garhwali"];
    const {
      ebooks: ebooksByLanguage,
      isLoading
    } = useLatestEbooksByLanguage(activeLanguage, {
      page: 1,
      limit: 10,
      uniqueSeries: true
    });
  
  // Handle language change
  const handleLanguageChange = (lang) => {
    setActiveLanguage(lang);
  };

  return (
    <div style={{ backgroundColor: "#1a1a1a" }}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h1 className={styles.title}>Selected For You</h1>
          
          <div className={styles.languageButtons}>
            {languages.map((lang) => (
              <button
                key={lang}
                className={`${styles.languageButton} ${
                  activeLanguage === lang ? styles.active : ""
                }`}
                onClick={() => handleLanguageChange(lang)}
              >
                {lang.charAt(0).toUpperCase() + lang.slice(1)}
              </button>
            ))}
          </div>
          
          <div className={styles.navigation}>
            <button ref={navigationPrevRef} className={styles.navButton}>
              <ChevronLeft size={24} />
            </button>
            <button ref={navigationNextRef} className={styles.navButton}>
              <ChevronRight size={24} />
            </button>
          </div>
        </div>

        <div className={styles.swiperContainer}>
          {isLoading ? (
            <div className={styles.loading}><Loading/></div>
          ) : (
            <Swiper
              modules={[Navigation, Mousewheel]}
              spaceBetween={20}
              mousewheel={{
                forceToAxis: true,
                invert: false,
                sensitivity: 1,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1.2,
                  spaceBetween: 10
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                1024: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                1200: {
                  slidesPerView: 2.5,
                  spaceBetween: 20
                }
              }}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current
              }}
              onBeforeInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
              }}
              className={styles.swiperCard}
            >
              {ebooksByLanguage && ebooksByLanguage && ebooksByLanguage.length > 0 ? (
                ebooksByLanguage?.map((book) => (
                  <SwiperSlide key={book.id}>
                    <EbookCard book={formatBookForCard(book)} />
                  </SwiperSlide>
                ))
              ) : (
                <div className={styles.noBooks}>No books available in {activeLanguage}</div>
              )}
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
}

// Helper function to format API data for the EbookCard component
function formatBookForCard(book) {
  return {
    id: book.id,
    title: book.title,
    image: book.cover_image_url_for_computer || book.cover_image_url_for_mbl,
    category: book.genre_name || "Unknown",
    tags: book.series?.series_type ? [book.series.series_type] : ["Ebook"],
    summary: book.description || "No description available",
    slug: book.slug,
    author: book.author || book.creator_name,
    series_id: book?.series?.id,
  };
}

export default BookCollection;